module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abacus-frame"
  }, [_c('div', {
    staticClass: "abacus",
    attrs: {
      "role": "grid",
      "aria-label": "Mayan abacus, 10 columns of vigesimal positional notation"
    }
  }, _vm._l((_vm.cols), function(col) {
    return _c('div', {
      key: 'c-' + col,
      staticClass: "column",
      style: ({
        animationDelay: ((col - 1) * 40) + 'ms'
      }),
      attrs: {
        "role": "row"
      }
    }, [_c('div', {
      staticClass: "bar bar-top",
      attrs: {
        "role": "gridcell"
      }
    }, _vm._l((_vm.topRows), function(row) {
      return _c('span', {
        key: 't-' + row,
        staticClass: "bead-slot"
      }, [_c('item', {
        attrs: {
          "bar": _vm.top,
          "row": row,
          "col": col
        }
      }, [_vm._v("5")])], 1)
    })), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "bar bar-bottom",
      attrs: {
        "role": "gridcell"
      }
    }, _vm._l((_vm.bottomRows), function(row) {
      return _c('span', {
        key: 'b-' + row,
        staticClass: "bead-slot"
      }, [_c('item', {
        attrs: {
          "bar": _vm.bottom,
          "row": row,
          "col": col
        }
      }, [_vm._v("1")])], 1)
    })), _vm._v(" "), _c('div', {
      staticClass: "glyph",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('div', {
      staticClass: "glyph-dots"
    }, _vm._l((_vm.colDots(col)), function(n) {
      return _c('span', {
        key: 'd-' + n,
        staticClass: "glyph-dot"
      })
    })), _vm._v(" "), _c('div', {
      staticClass: "glyph-bars"
    }, _vm._l((_vm.colBars(col)), function(n) {
      return _c('span', {
        key: 'gb-' + n,
        staticClass: "glyph-bar"
      })
    }))]), _vm._v(" "), _c('div', {
      staticClass: "position-label",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v(_vm._s(_vm.roman(col)))])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "henequen",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "henequen-knot"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-956704be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Abacus.vue
// module id = 66
// module chunks = 2